import React from "react";
import {
  DeleteWithConfirmButton,
  EditButton,
  useNotify,
  useRecordContext,
  useRefresh,
  useTranslate,
} from "react-admin";

import CancelIcon from "@mui/icons-material/Cancel";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { MobileDeleteWithConfirmButton } from "./MobileDeleteWithConfirmButton";
import { MobileEditButton } from "./MobileEditButton";

export const EditDeliveryButton = (props: any) => {
  const { showLabel, ...buttonProps } = props;
  const record = useRecordContext();
  if (!record) {
    return null;
  }
  const { status } = record;
  const editButton = showLabel ? (
    <MobileEditButton resource="spot_contract_individual_deliveries" />
  ) : (
    <EditButton {...buttonProps} resource="spot_contract_individual_deliveries" />
  );

  switch (status) {
    case "draft":
      return editButton;
    case "waiting_for_inspection": {
      if (record.delivery_type === "self_delivery") {
        return editButton;
      }
      return null;
    }
    default: {
      return null;
    }
  }
};

const hacobellUncancellableStatuses = [
  "shipment_delivered",
  "shipment_completed",
  "canceled",
  "rejected",
  "closed",
  "accepted",
  "unknown",
];

export const DeleteDeliveryButton = (props: any) => {
  const { showLabel, ...buttonProps } = props;
  const record = useRecordContext();
  const translate = useTranslate();
  const refresh = useRefresh();
  const notify = useNotify();
  if (!record) {
    return null;
  }

  const { delivery_type, hacobell, status } = record;
  const hacobellStatus = hacobell ? hacobell.status : "unknown";

  const mutationOptions = {
    onSuccess: () => {
      refresh();
      notify("ra.notification.deleted", { type: "info", messageArgs: { smart_count: 1 } });
    },
  };

  const DeleteButton = (deleteButtonProps: any) => {
    if (showLabel) {
      return (
        <MobileDeleteWithConfirmButton
          record={record}
          mutationMode="pessimistic"
          mutationOptions={mutationOptions}
          {...deleteButtonProps}
        />
      );
    }
    return (
      <DeleteWithConfirmButton
        {...buttonProps}
        mutationMode="pessimistic"
        mutationOptions={mutationOptions}
        {...deleteButtonProps}
      />
    );
  };

  switch (status) {
    case "draft": {
      return (
        <DeleteButton
          resource={"spot_contract_individual_deliveries"}
          redirect={false}
          confirmTitle={translate("ra.message.delete_title", {
            name: translate("ui.individual_deliveries.draft_delivery"),
          })}
          confirmContent={"ra.message.delete_content"}
        />
      );
    }
    case "waiting_for_arrangement": {
      if (delivery_type === "hacobell" && hacobellUncancellableStatuses.includes(hacobellStatus)) {
        return null;
      }
      return (
        <DeleteButton
          resource={"spot_contract_individual_deliveries"}
          redirect={false}
          label="ra.action.cancel"
          icon={<CancelIcon />}
          confirmTitle={translate("ui.individual_deliveries.cancel_title", {
            name: translate("ui.individual_deliveries.arranged_delivery"),
          })}
          confirmContent={"ui.individual_deliveries.cancel_content"}
        />
      );
    }
    case "waiting_for_inspection": {
      if (delivery_type === "hacobell") {
        if (hacobellUncancellableStatuses.includes(hacobellStatus)) {
          return null;
        }
        return (
          <DeleteButton
            resource={"spot_contract_individual_deliveries"}
            redirect={false}
            label="ra.action.cancel"
            icon={<CancelIcon />}
            confirmTitle={translate("ui.individual_deliveries.cancel_title", {
              name: translate("ui.individual_deliveries.arranged_delivery"),
            })}
            confirmContent={"ui.individual_deliveries.cancel_content"}
          />
        );
      }
      return null;
    }
    default: {
      return null;
    }
  }
};

export const InspectDeliveryButton = (props: any) => {
  const { showLabel, ...buttonProps } = props;
  const record = useRecordContext();
  if (!record) {
    return null;
  }
  const { status } = record;
  switch (status) {
    case "waiting_for_inspection": {
      return showLabel ? (
        <MobileEditButton
          resource="spot_contract_individual_delivery_after_delivery_inspections"
          label="ui.individual_deliveries.inspect"
          icon={<PlaylistAddCheckIcon />}
        />
      ) : (
        <EditButton
          {...buttonProps}
          resource="spot_contract_individual_delivery_after_delivery_inspections"
          label="ui.individual_deliveries.inspect"
          icon={<PlaylistAddCheckIcon />}
        />
      );
    }
    default: {
      return null;
    }
  }
};
